import styled from '@emotion/styled';

import { isEmpty } from 'lodash';

import {
  buildFormattedDateInString,
} from '../../../../shared/utils/productDetailState';
import {
  buildProductStorageText,
} from '../../../../shared/utils/productStorageUtil';

import { DeliveryInfo, ExtraInfo } from '../../../../types';
import { StorageType } from '../../../../../../shared/enums';

import ListItem from '../ListItem';
import ItemValue from './ItemValue';

const Container = styled.div`
  margin-top: 20px;
`;

interface InfoListProps {
  deliveryInfo: DeliveryInfo;
  salesUnit: string | null;
  volume: string | null;
  todayBrix: string | null;
  sellerName: string;
  productOrigin: string | null;
  storageTypes: StorageType[];
  allergy: string | null;
  expirationDate: string | null;
  soldOutText: string;
  extraInfos: ExtraInfo[];
  guides: string[];
  notSalesText: string;
  afterSaleServiceInfo: string;
}

export default function InfoList({
  deliveryInfo,
  salesUnit,
  volume,
  todayBrix,
  sellerName,
  productOrigin,
  storageTypes,
  allergy,
  expirationDate,
  soldOutText,
  extraInfos,
  guides,
  notSalesText,
  afterSaleServiceInfo,
}: InfoListProps) {
  const { deliveryName, deliveryGuide, isDelivery } = deliveryInfo;

  return (
    <Container>
      {deliveryName && (
        <ListItem title="배송">
          <ItemValue
            value={deliveryName}
            addText={deliveryGuide}
          />
        </ListItem>
      )}
      {sellerName && (
        <ListItem title="판매자">
          <ItemValue value={sellerName} />
        </ListItem>
      )}
      {(isDelivery && !isEmpty(storageTypes)) && (
        <ListItem title="포장타입">
          <ItemValue
            value={`${buildProductStorageText(storageTypes)} (종이포장)`}
            addText="택배배송은 에코 포장이 스티로폼으로 대체됩니다."
          />
        </ListItem>
      )}
      {salesUnit && (
        <ListItem title="판매단위">
          <ItemValue value={salesUnit} />
        </ListItem>
      )}
      {volume && (
        <ListItem title="중량/용량">
          <ItemValue value={volume} />
        </ListItem>
      )}
      {productOrigin && (
        <ListItem title="원산지">
          <ItemValue value={productOrigin} />
        </ListItem>
      )}
      {allergy && (
        <ListItem title="알레르기정보">
          <ItemValue value={allergy} />
        </ListItem>
      )}
      {expirationDate && (
        <ListItem title="유통기한정보">
          <ItemValue value={expirationDate} />
        </ListItem>
      )}
      {todayBrix && (
        <ListItem title="당도">
          <ItemValue value={todayBrix} />
        </ListItem>
      )}
      {extraInfos && extraInfos.map((info) => (
        <ListItem key={info.title} title={info.title}>
          <ItemValue value={info.description} />
        </ListItem>
      ))}
      {guides.length > 0 && (
        <ListItem title="안내사항">
          <ItemValue value={guides} />
        </ListItem>
      )}
      {notSalesText && (
        <ListItem title="판매상태">
          <ItemValue value={notSalesText} />
        </ListItem>
      )}
      {soldOutText && (
        <ListItem title="입고안내">
          <ItemValue value={buildFormattedDateInString(soldOutText)} />
        </ListItem>
      )}
      {afterSaleServiceInfo && (
        <ListItem title="A/S 안내">
          <ItemValue value={afterSaleServiceInfo} />
        </ListItem>
      )}
    </Container>
  );
}
